export default __webpack_public_path__ + "static/media/img-emptycalendar.94f8e64d.svg";